import { UserType } from '../../enums/user/userType.enum';
import { NavItem } from '../../interface/nav_items/nav_items.interface';

export const NAV_ITEMS_PROVIDER: NavItem[] = [
  {
    name: 'Dashboard',
    url: '/providers/dashboard',
    iconComponent: { name: 'cil-speedometer' },
    userType: UserType.PROVIDER,
  },
  {
    name: 'Gestion del Perfil',
    url: '/profile',
    iconComponent: { name: 'cil-user' },
    userType: UserType.PROVIDER,
    children: [
      {
        name: 'Actualizar Perfil',
        url: '/profile',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Directorio de Proveedores - Modificacion',
      },
    ],
  },
  // Fase 1: oculto del menú a pedido — la ruta /packages/scheduling sigue viva (la usan la
  // campana de notificaciones y el link "Ver servicios" desde Pago Proveedores), lo único que
  // no aplica hoy es dejarla como opción de navegación directa. Fase 2 la reincorpora.
  // {
  //   name: 'Notificacion de servicios',
  //   url: '/packages/scheduling',
  //   iconComponent: { name: 'cil-bell' },
  //   userType: UserType.PROVIDER,
  //   children: [
  //     {
  //       name: 'Reservas por Aceptar',
  //       url: '/packages/scheduling',
  //       icon: 'nav-icon-bullet',
  //       permissionGroup: [
  //         'Agendamiento de Servicios - Visualizacion',
  //         'Agendamiento de Servicios - Confirmacion',
  //       ],
  //     },
  //   ],
  // },
  {
    name: 'Gestion Estado Cuentas',
    url: '/providers/payment-services',
    iconComponent: { name: 'cil-credit-card' },
    userType: UserType.PROVIDER,
    children: [
      {
        name: 'Estado de Cuentas',
        url: '/providers/payment-services',
        icon: 'nav-icon-bullet',
        permissionGroup: 'Administracion Pago Proveedores - Visualizacion',
      },
    ],
  },
];
